import { render, staticRenderFns } from "./Fitogram.vue?vue&type=template&id=10f61b04&scoped=true"
import script from "./Fitogram.vue?vue&type=script&lang=js"
export * from "./Fitogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f61b04",
  null
  
)

export default component.exports